//import { split } from "core-js/fn/symbol";
import Vue from "vue";
import Vuex from "vuex";
var timer = 0
export default {
    translate(obj, lang) {
        var str = ""
        Object.keys(obj).forEach(key => {
            if (lang.toLowerCase() == obj[key].key.toLowerCase()) {
                if (obj[key].value != undefined) {
                    str = obj[key].value
                } else if (obj[key].val != undefined) {
                    str = obj[key].val
                }
            }
        })
        return str
    },
    setStartTime() {
        timer = new Date();
    },
    getDateFormat() {
        var current_datetime = new Date();
        //alert(current_datetime.getHours())
        return current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()
    },
    getUseTime() {
        let currTime = new Date() - timer;
        return Math.floor(currTime / 1000) //return as secound
    },
    setUserScore(Obj, useTime) {},
    setUserQuizScore(Obj, score) {
        Obj[0].score = score
        return Obj
    },
    setUserCriteria(Obj, useTime) {
        Obj[0].progressComplete.status = true;
        Obj[0].useTime = useTime;
        Obj[0].progressComplete.date = new Date().toISOString()
        Obj[0].userCriteria.forEach(el => {
            if (el.value == false) {
                el.value = true
                el.date = new Date().toISOString()
            }
        })
        return Obj
    },
    getTopicIDByNumber(obj, number) {
        let id = ""
        obj.filter(el => {
            if (el.topic.topicNumber == number) {
                id = el.topic._id
                return
            }
        });
        return id
    },
    getUsetimeInHour(number) { // input at sec
        return (number / (60 * 60)).toFixed(2)
    },
    getUsetimeInMin(number) { // input at sec
        return (number / (60)).toFixed(2)
    },
    setChineseUrl(data) {
        let str = data.split("-");
        let body = "/" + str[0] + "/" + str[1];
        return body
    },
    checkHistoryTemplate(code) {
        this.$store.dispatch("template/fetchHistoryTemplate");
    },
    updatePathCHN(path) {
        var split_path = path.split("-");
        var real_path = split_path[0] + "/" + split_path[1];
        return real_path
    }
}